import React, { Fragment, useState } from "react";
import RedMarkerIcon from "../../../assets/images/marker-icon.png";
// import BlueMarkerIcon from "../../../assets/images/Blue-marker-icon.png";
import { Link } from "react-router-dom";

interface Location {
  lat: number;
  lng: number;
  name: string;
  address?: string;
  image?: string;
  itemName?: string;
  _id?: string;
  propertyAddress?: string;
}

interface CustomMarkerProps extends Location {
  isActive: boolean;
  onClick: () => void;
  showNumberLabel?: boolean;
  onMarkerHover: (marker: {
    lat: number;
    lng: number;
    address?: string;
    top?: number;
    right?: number;
    propertyAddress?: string;
  }) => void;
  onMarkerLeave: () => void;
  showInfoWindow?: boolean;
  includeImageInMarker?: boolean;
  onView?: (id: string) => void;
  location: Location;
}

const CustomMarker: React.FC<CustomMarkerProps> = ({
  lat,
  lng,
  name,
  address,
  propertyAddress,
  isActive,
  onClick,
  showNumberLabel,
  onMarkerHover,
  onMarkerLeave,
  showInfoWindow,
  includeImageInMarker,
  location,
  onView,
}) => {
  const [showInfo, setShowInfo] = useState(showInfoWindow);

  React.useEffect(() => {
    setShowInfo(showInfoWindow);
  }, [showInfoWindow]);

  const handleMarkerClick = () => {
    setShowInfo(!showInfo);
  };

  return (
    <div
      className="map-popup"
      style={{
        position: "absolute",
        width: "100%",
        height: "80px", // Increase the height to accommodate the text box below the icon
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        zIndex: showInfo ? 2 : 1,
      }}
      onClick={() => {
        onClick();
        handleMarkerClick();
      }}
      onMouseEnter={() => {
        handleMarkerClick();
      }}
      onMouseLeave={() => {
        handleMarkerClick();
      }}
    >
      {showNumberLabel ? (
        <Fragment>
          <div className="marker-icon">{name}</div>
          {showInfo && !includeImageInMarker && (
            <div
              style={{
                position: "absolute",
                top: "-50px", // Adjust this value to move the info window above the marker
                left: "-50%", // Center the info window horizontally
                zIndex: 1000,
                width: "314px",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div className="map-modal bg-white p-3 text-left mb-4">
                <div className="row gutter-10">
                  <div className="col">
                    <h3 className="font-normal mb-2">{address}</h3>
                    <div className="text-muted font-xs pb-1">
                      {propertyAddress}
                    </div>
                  </div>
                  <div className="col-auto">
                    <a
                      href={`https://www.google.com/maps?q=${lat},${lng}`}
                      target="_blank"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.68075 14.3115C6.84742 14.4782 7.03908 14.5615 7.25575 14.5615C7.47242 14.5615 7.66408 14.4782 7.83075 14.3115L14.2615 7.88075C14.4282 7.71408 14.5115 7.51408 14.5115 7.28075C14.5115 7.04742 14.4282 6.84742 14.2615 6.68075L7.83075 0.25C7.66408 0.0833333 7.47242 0 7.25575 0C7.03908 0 6.84742 0.0833333 6.68075 0.25L0.25 6.68075C0.0833333 6.84742 0 7.04742 0 7.28075C0 7.51408 0.0833333 7.71408 0.25 7.88075L6.68075 14.3115ZM5.03075 7.03075V9.28075C5.03075 9.49325 4.95883 9.67133 4.815 9.815C4.67117 9.95883 4.493 10.0308 4.2805 10.0308C4.06783 10.0308 3.88975 9.95883 3.74625 9.815C3.60258 9.67133 3.53075 9.49325 3.53075 9.28075V6.28075C3.53075 6.05575 3.5995 5.8745 3.737 5.737C3.8745 5.5995 4.05575 5.53075 4.28075 5.53075H9.04625L8.2385 4.70775C8.1 4.55892 8.02917 4.38483 8.026 4.1855C8.02283 3.98617 8.0995 3.80825 8.256 3.65175C8.3995 3.50825 8.57442 3.4365 8.78075 3.4365C8.98708 3.4365 9.16275 3.50892 9.30775 3.65375L11.302 5.648C11.4827 5.82883 11.573 6.03975 11.573 6.28075C11.573 6.52175 11.4827 6.73267 11.302 6.9135L9.30775 8.90775C9.16925 9.04608 8.99517 9.11692 8.7855 9.12025C8.576 9.12341 8.39292 9.04675 8.23625 8.89025C8.09292 8.74675 8.02125 8.57692 8.02125 8.38075C8.02125 8.18458 8.09367 8.00892 8.2385 7.85375L9.04625 7.03075H5.03075Z"
                          fill="#002AB2"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showInfo && includeImageInMarker && (
            <div
              style={{
                position: "absolute",
                top: "-50px", // Adjust this value to move the info window above the marker
                left: "-50%", // Center the info window horizontally
                zIndex: 1000,
                width: "314px",
                transform: "translate(-50%, -50%)",
              }}
              className="listing d-flex py-2 border-top px-2 cursor-pointer"
            >
              <div className="map-modal bg-white p-3 text-left mb-4">
                <div className="row gutter-10">
                  <figure className="col-auto">
                    {location?.image && (
                      <img
                        src={location?.image}
                        alt="test"
                        width="59"
                        height="45"
                        className="img-cover"
                      />
                    )}
                  </figure>
                  <figcaption className="col text-left">
                    <h3 className="font-sm mb-0 pb-1">{location.itemName}</h3>
                    <div className="location text-gray-500 font-sm">
                      <span className="text-gray-500"> Location: </span>
                      {address}
                    </div>
                    <div>
                      <button
                        onClick={() => onView?.(location?._id!)}
                        className="btn btn-primary px-1 font-sm font-weight-semibold py-1 mt-1 rounded"
                      >
                        View Details
                      </button>
                    </div>
                  </figcaption>
                </div>
              </div>
            </div>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <img
            src={RedMarkerIcon}
            alt="Red Marker Icon"
            //   style={{
            //     width: "20px",
            //     height: "10px",
            //   }}
          />

          <div
            style={{
              backgroundColor: "white",
              border: "1px solid #4161c8",
              borderRadius: "5px",
              alignItems: "center",
              color: "#4161c8",
              whiteSpace: "nowrap",
              width: "310px",
              textOverflow: "ellipsis",
              overflow: "hidden",
              paddingLeft: "10px",
              paddingRight: "10px",
              paddingTop: "5px",
              paddingBottom: "5px",
              fontSize: "13px",
            }}
          >
            {name}

            {showInfo && !includeImageInMarker && (
              <div
                style={{
                  position: "absolute",
                  top: "-50px", // Adjust this value to move the info window above the marker
                  left: "-50%", // Center the info window horizontally
                  borderRadius: "5px",
                  backgroundColor: "white",
                  paddingTop: "5px",
                  paddingRight: "5px",
                  paddingLeft: "5px",
                  border: "1px solid #ccc",
                  zIndex: 1000,
                }}
              >
                <h3 className="font-sm font-weight-normal text-primary">
                  {name}. {address}
                </h3>
              </div>
            )}
            {showInfo && includeImageInMarker && (
              <div
                style={{
                  position: "absolute",
                  top: "-50px", // Adjust this value to move the info window above the marker
                  left: "-50%", // Center the info window horizontally
                  borderRadius: "5px",
                  backgroundColor: "white",
                  paddingTop: "5px",
                  paddingRight: "5px",
                  paddingLeft: "5px",
                  border: "1px solid #ccc",
                  zIndex: 1000,
                  width: "350px",
                }}
                className="listing d-flex py-2 border-top px-2 cursor-pointer"
              >
                <figure>
                  {location?.image && (
                    <img
                      src={location?.image}
                      alt="test"
                      width="59"
                      height="45"
                      className="img-cover"
                    />
                  )}
                </figure>
                <figcaption className="pl-3">
                  <h3 className="font-sm mb-0 pb-1">{location.itemName}</h3>
                  <div className="location text-gray-500 font-sm">
                    <span className="text-gray-500"> Location: </span>
                    {address}
                  </div>
                  <div className="col-md-12 col-12 text-center">
                    <button
                      onClick={() => onView?.(location?._id!)}
                      className="btn btn-primary px-1 font-sm font-weight-semibold py-1 mt-1 rounded"
                    >
                      View Details
                    </button>
                  </div>
                </figcaption>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default CustomMarker;
